import React from 'react';
import classNames from 'classnames';
import { isFunction } from 'lodash';
import { KabobMenu, Tooltip } from 'Permafrost/index';
import { StyledCard } from './Card.styles';
export const Card = (card) => {
    const { id, className, description, disabled, disabledTooltip, footer, header, kabobMenuOptions, selectable, style, title, } = card;
    return (React.createElement(StyledCard, { id: id, className: classNames(className, {
            disabled: disabled === true,
            selectable: isFunction(selectable === null || selectable === void 0 ? void 0 : selectable.onSelect) === true,
            selected: (selectable === null || selectable === void 0 ? void 0 : selectable.selected) === true,
        }), "data-tip": true, "data-for": id, "data-tip-disable": !disabled, onClick: () => {
            if (!disabled)
                selectable === null || selectable === void 0 ? void 0 : selectable.onSelect();
        }, style: style, "data-testid": card['data-testid'] },
        disabledTooltip ? React.createElement(Tooltip, { for: id }, disabledTooltip) : null,
        React.createElement("header", { className: "Card--header-container" },
            React.createElement("div", { className: "header" }, header),
            kabobMenuOptions ? (React.createElement(KabobMenu, { id: `${id}-kabob-menu`, className: "kabob", disabled: disabled, menuOptions: kabobMenuOptions })) : null),
        React.createElement("div", { className: "Card--content-container" },
            React.createElement("div", { className: "body-container" },
                React.createElement("header", null,
                    React.createElement("span", { className: "title" }, title)),
                description ? React.createElement("p", { className: "desc" }, description) : null),
            footer ? React.createElement("div", { className: "footer" }, footer) : null)));
};
//# sourceMappingURL=Card.js.map